import AlertDialog from './alert';
import ConfirmDialog from './confirm';
import CustomDialog from './custom';
import NormalDialog from './normalDialog';

export { AlertDialog, ConfirmDialog, CustomDialog, NormalDialog };
